export default function cleanEnhancer(reducer, compareAction) {
    return function cleanerReducer(state, action) {
        if (action.type === compareAction) {
            return reducer(undefined, action);
        } else {
            return reducer(state, action);
        }
    };
}
